export const Time = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
<path d="M16 7V16L21.2981 21.2981" stroke="currentColor" stroke-width="2"/>
</svg>`;
